import { type ServiceRequest, serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { GetNoticesResponse, NoticesApiGetNoticesRequest } from 'viewup-api/v2';

export type GetNoticesReq = ServiceRequest<NoticesApiGetNoticesRequest>;
export type GetNoticesRes = GetNoticesResponse;

export const getNotices = async (req: GetNoticesReq) => {
  const { data: response } = await serviceApi.notice.getNotices(withServiceRequestDefaults(req));
  return response;
};
